import { taasInfoReducer } from '@ps20-frontend/preis-lib';
import { AnyAction } from 'redux';
import { App, TaasInfo } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';

export const vwgTaasInfoReducer = function (
  sectionState: TaasInfo = null,
  action: AnyAction,
  appState: IAppState,
): TaasInfo {
  return taasInfoReducer(sectionState, action, App.VWG_V2, appState?.angebotsId);
};
